export default __webpack_public_path__ + "static/showerHead@2x-363535ac39d687a49a65dc36c381d368.webp";